module.exports = __webpack_public_path__ + "img/混动.a98c1c7b.png";